module.exports = __webpack_public_path__ + "static/media/gr.6911d460.svg";